export class WCupSeasonItem {

  public year: number;
  public disciplineId: number;

  constructor(rawWCupSeasonItem: any) {
    this.year = +rawWCupSeasonItem.Year;
    this.disciplineId = +rawWCupSeasonItem.Discipline;
  }
}